<template>
  <div class="m-0 dbozone-font bg-crazyworm" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-crazyworm">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -crazyworm`">{{ $t('3_5_base.paytable.symtable_title') }}</h5>
        </section>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row">
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/crazyworm/symbol_1.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex align-items-center mt-3 ml-4">
          <span class="font-weight-bold text-sub" :class="`-${lang}`">
            {{$t('3_5_base.paytable.symtable_wild1')}} <br>
            {{$t('3_5_base.paytable.symtable_scatter')}}
          </span>
        </div>
        <div class="col-3 p-0">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/crazyworm/symbol_0.png`)" alt="">
        </div>
        <div class="col-3 align-items-center p-0 d-flex mt-3 ml-4">
          <span class="font-weight-bold text-sub" :class="`-${lang}`">
            {{$t('3_5_base.paytable.symtable_wild1')}} <br>
            {{$t('3_5_base.paytable.symtable_wild2')}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/crazyworm/symbol_2.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 ml-4 align-items-center">
          <span class="text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[2][3]}} <br>
            {{'4 - ' + paytable[2][2]}} <br>
            {{'3 - ' + paytable[2][1]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/crazyworm/symbol_3.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 ml-4 align-items-center">
          <span class="text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[3][3]}} <br>
            {{'4 - ' + paytable[3][2]}} <br>
            {{'3 - ' + paytable[3][1]}}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/crazyworm/symbol_4.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 ml-4 align-items-center">
          <span class="text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[4][3]}} <br>
            {{'4 - ' + paytable[4][2]}} <br>
            {{'3 - ' + paytable[4][1]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/crazyworm/symbol_5.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 ml-4 align-items-center">
          <span class="text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[5][3]}} <br>
            {{'4 - ' + paytable[5][2]}} <br>
            {{'3 - ' + paytable[5][1]}}
          </span>
        </div>
      </div>
      <div class="col-12 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/crazyworm/symbol_6.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 ml-4 align-items-center">
          <span class="text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[6][3]}} <br>
            {{'4 - ' + paytable[6][2]}} <br>
            {{'3 - ' + paytable[6][1]}}
          </span>
        </div>
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/crazyworm/symbol_7.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 ml-4 align-items-center">
          <span class="text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[7][3]}} <br>
            {{'4 - ' + paytable[7][2]}} <br>
            {{'3 - ' + paytable[7][1]}}
          </span>
        </div>
      </div>
      <div class="col-12 mt-3 justify-content-center d-flex flex-row mt-5">
        <div class="col-3 p-0 align-items-center d-flex">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/crazyworm/symbol_8.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 ml-4 align-items-center">
          <span class="text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[8][3]}} <br>
            {{'4 - ' + paytable[8][2]}} <br>
            {{'3 - ' + paytable[8][1]}}
          </span>
        </div>
        <div class="col-3 p-0 d-flex align-items-center">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/resultGame/crazyworm/symbol_9.png`)" alt="">
        </div>
        <div class="col-3 p-0 d-flex mt-2 ml-4 align-items-center">
          <span class="text-sub" :class="`-${lang}`">
            {{'5 - ' + paytable[9][3]}} <br>
            {{'4 - ' + paytable[9][2]}} <br>
            {{'3 - ' + paytable[9][1]}}
          </span>
        </div>
      </div>
      <div class="d-flex flex-column nav-crazyworm mt-5">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -crazyworm`">{{ $t('3_5_base.freespin') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('3_5_base.text-freespin1') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('3_5_base.text-freespin2') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('3_5_base.text-freespin3') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('3_5_base.text-freespin4') }}</span>
      </div>
      <div class="d-flex p-2 mt-1 mb-2">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('3_5_base.text-freespin5') }}</span>
      </div>

      <div class="d-flex flex-column nav-crazyworm mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -crazyworm`">{{ $t('featurebuy.title') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1 mb-2 justify-content-center">
        <img class="mt-3 icon-startbutton" :src="require(`../../assets/paytable/crazyworm/feature_buy_${imgLang}.png`)"
          alt="">
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('featurebuy.text1') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('featurebuy.text2') }}</span>
      </div>

      <div class="d-flex flex-column nav-crazyworm mt-4">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang} -crazyworm`">{{ $t('3_5_base.line') }}</h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-3">
        <span class=" m-0 text-bet-line" :class="`-${lang}`">{{ $t('3_5_base.text-line1') }}</span>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('3_5_base.text-line2') }}</span>
      </div>
      <div class="d-flex p-2 mb-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('3_5_base.text-line3') }}</span>
      </div>
      <div class="justify-content-center d-flex flex-row">
          <img class="mt-3 icon-paytable" :src="require(`../../assets/paytable/pay/3_5_combo.png`)" alt="">
      </div>
      <div class="d-flex p-2 mb-1 justify-content-center">
        <span class=" m-0 text-sub-center" :class="`-${lang}`">{{ $t('3_5_base.text-line4') }}</span>
      </div>
      <div class="d-flex p-2 mb-5">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('3_5_base.text-line5') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'paytable-ghost',
  props: {
    data: Object,
    lang: String,
    imgLang: String
  },
  data() {
    return {
      paytable: this.data.config.payTable
    }
  }
}
</script>

<style>

.icon-paytable {
  width: 100%;
}

.content {
  background: #000013;
  height: 100%;
  width: 100%;
  background-size:cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

@media screen and (max-width: 768px) {
  .header > div {
    flex-grow: 0;
    width: 33.33%;
  }
}

</style>